import Vue from "vue"

Vue.filter("format_date", (date, formatStr) => {
    return moment(date).format(formatStr);
});

Vue.filter("format_time", (date, formatStr = 'HH:mm') => {
    return moment(date).format(formatStr);
});

Vue.filter("parse_date", (date, formatStr) => {
    console.log(222222222, date, formatStr);
    return moment(date, formatStr);
});
